import SSearch from './s-search.jsx'

SSearch.install = function(Vue) {
  Vue.component(SSearch.name, SSearch)
}

export default SSearch